import * as React from "react";

const FormContext = React.createContext<FormContextProps | null>(null);

/**
 * <FormProvider>
 */
function FormProvider(props: FormProviderProps) {
	return (
		<FormContext.Provider value={{ isForm: true }}>
			{props.children}
		</FormContext.Provider>
	);
}

interface FormContextProps {
	isForm: true;
}

interface FormProviderProps {
	children: JSX.Element;
}

export { FormContext, FormProvider, type FormContextProps };
